import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { CookiesService } from '~shared/services/coookies.service';
import { AppState } from '@core/store';
import { Store } from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
	constructor(private readonly _cookiesService: CookiesService, private store: Store<AppState>) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let clonedRequest: any;
		if (req.url.indexOf('sumax-erp-backend-maestros-sync') !== -1) {
			clonedRequest = this._cookiesService.getBearerAuthorization('maestroSyncToken');
			let headers = new HttpHeaders({ Authorization: clonedRequest });
			return next.handle(req.clone({ headers }));
		} else {
			 clonedRequest = this._cookiesService.getBearerAuthorization('idToken');
    		let headers = new HttpHeaders({ Authorization: clonedRequest });
    		return next.handle(req.clone({ headers }));
		}
	}
}

export const authInterceptorProviders = {
	provide: HTTP_INTERCEPTORS,
	useClass: AuthInterceptorService,
	multi: true,
};
